/** Auctions */
export default [
  /** Auctions */
  {
    path: '/alhondiga/auctions/frmAuctions',
    asyncComponent: () => import('@/pages/alhondiga/auctions/FrmAuctions.vue'),
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/alhondiga/auctions/frmAuctionsOperations',
    asyncComponent: () => import('@/pages/alhondiga/auctions/FrmAuctionsOperations.vue'),
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/alhondiga/auctions/frmAuctionsSalesOrderLine',
    asyncComponent: () => import('@/pages/alhondiga/auctions/FrmAuctionsSalesOrderLine.vue'),
    meta: {
      useNewStyles: true,
    },
  },
  {
    path: '/alhondiga/auctions/frmAuctionsSalesOrderNewLine',
    asyncComponent: () => import('@/pages/alhondiga/auctions/FrmAuctionsSalesOrderNewLine.vue'),
    meta: {
      useNewStyles: true,
    },
  },
];
